/* eslint-disable */
const ReactRailsUJS = require(`react_ujs`);

ReactRailsUJS.useContext(
  require.context(`applications/components/HeaderApp`, true)
);
